export default __webpack_public_path__ + "static/Banat_IT_Logo-deed1ac8c22fd5ace33ee8dd5cdb31e7.svg";